export enum CommonEvents {
    PreUndo = 'preundo',
    PreUndoSplit = 'preundosplit',
    DeleteTrack = 'deletetrack',
    InfoMessage = 'infomessage'
}